import Barba from 'barba.js'
import $ from 'jquery'
import intro from '../../modules/intro.js'
import slider from '../../modules/slider.js'
import listHover from '../../modules/list-hover.js'
import map from '../../modules/map.js'

var homeView = function() {

  var Home = Barba.BaseView.extend({
    namespace: 'home',
    onEnter: function() {
      $('.header__nav').fadeIn(400);

      if(window.innerWidth < 800 && !$('.header__nav').hasClass('sub-active')) {
        $('.header').addClass('nav-down');
      }

      $('body').addClass('horizontal-top');

      intro();
      slider();
      listHover();
      map();
    },
    onEnterCompleted: function() {
      $(window).scroll();
    },
    onLeave: function() {
      $('body').removeClass('horizontal-top');
      $('.header').removeClass('sub-active');
      $('.header__nav').fadeOut(400);
    },
    onLeaveCompleted: function() {
    }
  });

  Home.init();
}

module.exports = homeView;



// WEBPACK FOOTER //
// ./resources/assets/js/barba/views/home-view.js